
import common from "../../api/common";
import Loading from 'vux/src/components/loading/index.vue'

export default {
data() {
return {
loading1:false,
arr:[],
docid: "",
item: {},
datalist: "",
skillname: [],
arguedis:[],
counts: "",
isbuy: 0,
istrue: 0,
pinglun:{},
disturb:'',//是否免打扰
showLoading: false,
loadText: '数据加载中',

bindid:'',

imageUrl:'',

textInfo:'',
isConfirm:false,

patientInfo:false,
patientPhone:'',
patientName:'',
patientIdcard:''
};
},
methods: {
query() {
this.showLoading = true;
var _this = this;
this.$doRequest(
"/api/AppHomePage/Index",
{
parameters: _this.docid,
twoParameter: _this.$store.state.AllOfValue.ImDoctorInfo!=undefined ?_this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId:_this.$store.state.userInfo.id,
},
res => {
_this.showLoading = false;
_this.disturb=res.isNoDisturb;
if (res.doctornotice != null) {
res.doctornotice.year = new Date(
res.doctornotice.updatetime
).getFullYear();
res.doctornotice.month =
new Date(res.doctornotice.updatetime).getMonth() + 1;
res.doctornotice.day = new Date(
res.doctornotice.updatetime
).getDate();
res.doctornotice.time = common.timestampToTime(
res.doctornotice.updatetime
);
}
this.datalist = res;
if(res.skillname!=null){
this.skillname = res.skillname.split(",");
}
if(res.arguedis!=null){
this.arguedis = res.arguedis.split(",");
}
var inquiringprice = this.$store.state.common.inquiringprice;
this.isbuy = res.isBuy;
this.$store.state.isBuy = res.isBuy;
var datas = inquiringprice.filter(function(item) {
return item.itemcode;
});

let price = res.isBuy == 0 ? res.thagainprice : res.thaskprice;
console.log(datas);

datas.find((obj) => {
if (obj.itemcode == price) {
this.counts = obj.itemname;
}
})

















this.$store.state.sun.price = this.counts;
if(this.$route.query.isbuy=='1'){
this.$router.push({ path: "/buyServiceDetails"});
}
});
},
gotoinfo() {
if(this.$store.state.userInfo.telephone==''||this.$store.state.userInfo.telephone==null||!this.$store.state.userInfo.telephone){
this.$router.push({path: '/boundPhone',query:{form:'doctorDetails'}});
}
else
if(this.datalist.isOrder!=0){



this.$router.push({ path: "/buyServiceDetails" });
}
},
yuyue(){
this.patientInfo=true;
},
conceal(){
this.patientInfo=false;
this.patientPhone='';
this.patientName=''
this.patientIdcard=''
},
confirm(){
if(this.patientPhone==''||this.patientPhone==null){
this.$toastMsg("请输入患者手机号");
return;
};
if(this.patientName==''||this.patientName==null){
this.$toastMsg("请输入患者姓名");
return;
};





var _this=this;
var param={

"bindId": _this.bindid,     // 参数中的bindId
"userTel": _this.patientPhone, // 用户手机号
"userName": _this.patientName, //用户姓名
"userIdcard": _this.patientIdcard, //用户身份证号

"doctorId":_this.docid, //医生id
}
_this.$axios({


url: 'https://api.51bjhzy.com/relationship',
method: 'post',
data: param
}).then(res => {
if(res.data.code==200){
_this.$toastMsg("预约成功");
_this.conceal()
_this.imageUrl=res.data.data.image
_this.textInfo=res.data.data.text
_this.isConfirm=true;
}else{
_this.$toastMsg("未查询到医生出诊信息");
_this.isConfirm=false;
}
console.log("调用了")
}).catch()









},
allBudject(){
if(this.pinglun.length>0)
{this.$router.push({ path: '/allBudject',query: {id: this.docid}});}
},
routerToNotice(){
this.$router.push({ path: '/notice',query: {id: this.docid}});
},
routerToNoticeDetails(datas){
this.$router.push({ path: '/noticeDetails',query: {data: datas}})
},
guanzhu(){

if(this.$store.state.userInfo.telephone==''||this.$store.state.userInfo.telephone==null||!this.$store.state.userInfo.telephone){
this.$router.push({path: '/boundPhone',query:{form:'doctorDetails'}});
return;
}
var _this=this;
var param={
doctorid:_this.docid,
patientid:_this.$store.state.userInfo.id,
number:this.datalist.isFonce==1?'0':'1'
}
this.$doRequest(
"/api/AppHomePage/fonce", param, res => {
if(res.message=='关注成功'){
_this.$toastMsg("关注成功");
_this.query();
}else{
_this.$toastMsg("取消关注成功");
_this.query();
}

}
);
},
changeLoading(){
if(this.loading1==true){
this.loading1=false;
}else{
this.loading1=true;
}
},
queryComment(){
let data = {
"doctorId":this.docid,
condition: {
"doctorId":this.docid,
status:2,
"patientId":this.$store.state.userInfo.id,
"patientendFlag":1,
}
};
let _this = this;
this.$doRequest('/api/judge/getjudgelistPage', data, res=>{
for(let i=0;i<res.parameters.rows.length;i++){
res.parameters.rows[i].telephone= "" + res.parameters.rows[i].telephone;
let ary = res.parameters.rows[i].telephone.split("");
ary.splice(3,7,"*******");
res.parameters.rows[i].telephone=ary.join("");
if(res.parameters.rows[i].commentlabel!=''){
res.parameters.rows[i].commentlabel=  res.parameters.rows[i].commentlabel.split(',');
}
}
_this.pinglun=res.parameters.rows;
})
},

goConfirm(e){
this.isConfirm=e
},

},

mounted: function() {

},

created: function() {
if(!this.$store.state.userInfo.sessionId){
this.$store.state.userInfo.sessionId = 'haozhongyi';
}
document.title = '复诊医生';
var state = common.getQueryString(window.location.search.substr(1),"state");
var doctorId = common.getQueryString(window.location.search.substr(1),"doctorId");
console.log(doctorId,"医生id")
var bindid = common.getQueryString(window.location.search.substr(1),"bindId")
if(state!=null&&state!=''&&doctorId!=null&&doctorId!=''){
if(bindid!=null&&bindid!=''){
this.bindid = bindid
}
this.docid =doctorId;
this.$store.state.AllOfValue.doctorId=doctorId;
if (state== "g8t7r3") {
this.istrue = 1;
} else {
this.istrue = 0;
}
}else{
this.docid = this.$store.state.AllOfValue.doctorId;
if (this.$route.query.state == "g8t7r3") {
this.istrue = 1;
} else {
this.istrue = 0;
}
}
this.queryComment();
this.$isLogin(window.location.search.substr(1), this.query);
},

updated: function() {},

destroyed: function() {},
watch: {
istrue: function(value, newvalue) {
this.istrue = value;
}
}
};



// WEBPACK FOOTER //
// ./src/views/doctorDetails/index.vue